<template>
  <generic-container icon="credit card" :title="$t('visa transactions')">
    <div class="ui form">
      <div class="ui dividing small header">
        <i class="search icon"></i> {{ $t("transaction search") }}
      </div>
      <div class="three fields">
        <div class="field">
          <label>{{ $t("start date") }}</label>
          <div class="ui calendar" ref="range_start">
            <div class="ui input left icon">
              <i class="calendar icon"></i>
              <input
                type="text"
                :placeholder="$t('start date')"
                v-model="start_date"
              />
            </div>
          </div>
        </div>
        <div class="field">
          <label>{{ $t("end date") }}</label>
          <div class="ui calendar" ref="range_end">
            <div class="ui input left icon">
              <i class="calendar icon"></i>
              <input
                type="text"
                :placeholder="$t('end date')"
                v-model="end_date"
              />
            </div>
          </div>
        </div>
        <div class="field">
          <label>'</label>
          <div
            class="ui blue icon labeled fluid button"
            @click="get_transactions"
          >
            <i class="check icon"></i> {{ $t("get transactions") }}
          </div>
        </div>
      </div>
    </div>
    <table
      class="ui blue very compact celled striped selectable table"
      ref="table"
      style="width:100%"
    >
      <thead>
        <tr>
          <th>{{ $t("date") }}</th>
          <th>{{ $t("card number") }}</th>
          <th>{{ $t("amount") }}</th>
          <!-- <th>{{ $t("type") }}</th> -->
          <th>{{ $t("status") }}</th>
          <th>{{ $t("reference number") }}</th>
          <th>{{ $t("authorization number") }}</th>
          <th>{{ $t("response code") }}</th>
          <!-- <th>{{ $t("message type") }}</th> -->
        </tr>
      </thead>
      <tbody></tbody>
    </table>
    <transaction-modal
      v-if="show_transaction_modal"
      @close="show_transaction_modal = false"
      ref="transaction_modal"
    />
  </generic-container>
</template>

<script>
import filters from "@/filters";
import {
  local_api,
  stringify,
  init_json_local_data_datables,
  enterprise_setup,
} from "@/utils";
import GenericContainer from "@/components/GenericContainer";
import ConfigureModal from "./configuration_modal/Index.vue";
import TransactionModal from "./transaction_modal/Index.vue";
import { translate_status /*, translate_type*/ } from "./local_translator";
import ResponseCodes from "./visa_payment_response_codes";

// @ is an alias to /src
export default {
  name: "VisaPaymentIndex",
  components: {
    "generic-container": GenericContainer,
    TransactionModal,
  },
  filters: filters,
  data() {
    return {
      configure_modal: ConfigureModal,
      start_date: "",
      end_date: "",
      transactions: [],
      show_transaction_modal: false,
    };
  },
  methods: {
    findResponse(code) {
      let trgt = ResponseCodes.find((r) => r.code == code);
      if (trgt) return "[" + code + "] " + trgt.description;
      else return code;
    },
    get_transactions() {
      let vm = this;
      let ent_setup = enterprise_setup(vm);
      local_api(vm, "post", "/visa_payment/transaction/do-get-list", {
        s: vm.start_date,
        e: vm.end_date,
      })
        .then((transactions) => {
          vm.transactions = transactions;

          let columns = [
            {
              data: function(row) {
                // console.log(row);
                return filters.formatDate(
                  row.create_date,
                  ent_setup.detailed_date_format,
                );
              },
            },
            {
              data: function(row) {
                return row.request_data.pan;
              },
            },
            {
              data: function(row) {
                return (
                  filters.formatVisaCurrency(row.request_data.amount) || ""
                );
              },
            },
            // {
            //   data: function(row) {
            //     return translate_type(row.type_code, vm) || "";
            //   },
            // },
            {
              data: function(row) {
                return translate_status(row.status_code, vm) || "";
              },
            },
            {
              data: function(row) {
                let ret =
                  row.response_data &&
                  row.response_data.result &&
                  row.response_data.result.response
                    ? row.response_data.result.response.referenceNumber
                    : "";
                return ret || "";
              },
            },
            {
              data: function(row) {
                let ret =
                  row.response_data &&
                  row.response_data.result &&
                  row.response_data.result.response
                    ? row.response_data.result.response.authorizationNumber
                    : "";
                return ret || "";
              },
            },
            {
              data: function(row) {
                let ret =
                  row.response_data &&
                  row.response_data.result &&
                  row.response_data.result.response
                    ? row.response_data.result.response.responseCode
                    : "";
                let rr = vm.findResponse(ret);
                return rr || "";
              },
            },
            // {
            //   data: function(row) {
            //     let ret =
            //       row.response_data &&
            //       row.response_data.result &&
            //       row.response_data.result.response
            //         ? row.response_data.result.response.messageType
            //         : "";
            //     return ret || "";
            //   },
            // },
          ];
          let onSelect = function(data) {
            vm.show_transaction_modal = true;
            setTimeout(() => {
              vm.$refs.transaction_modal.updateTransaction(data.uuid);
            }, 200);
          };
          // let onCreatedRow = () => {};

          init_json_local_data_datables(
            vm,
            vm.$refs.table,
            transactions,
            columns,
            onSelect,
            function(tr, data) {
              let $tr = window.jQuery(tr);
              if (data.status_code == "E") {
                $tr.addClass("error");
              }
              if (data.type_code == "V") {
                $tr.addClass("warning");
              }
              // $tr.hover(function() {
              //   if (data.status_code == "E") {
              //     $tr
              //       .popup({
              //         on: "click",
              //         // preserve: true,
              //         title: vm.$t("error detail"),
              //         content: data.response_data.err.body,
              //         lastResort: true,
              //       })
              //       .popup("toggle");
              //   }
              // });
            },
            null,
          );
        })
        .catch((err) => {
          console.log(err);
          vm.$alertify.error(stringify(err));
        });
    },
  },
  created() {},
  mounted() {
    let vm = this;

    window.jQuery(vm.$refs.range_start).calendar({
      today: true,
      type: "datetime",
      endCalendar: window.jQuery(vm.$refs.range_end),
      onSelect(value) {
        vm.start_date = value;
      },
    });
    window.jQuery(vm.$refs.range_end).calendar({
      today: true,
      type: "datetime",
      startCalendar: window.jQuery(vm.$refs.range_start),
      onSelect(value) {
        vm.end_date = value;
      },
    });
  },
  watch: {},
};
</script>
